import { RANGES, type Range } from "@bt/core/periods";
import { navigate, useLocation } from "@/lib/pages";

/**
 * What the pages show (ADR 0016): the installation and the range, kept in the query string
 * (?installation=app&range=12m) so a link or a reload shows the same.
 */

export const DEFAULT_INSTALLATION = "app";
export const DEFAULT_RANGE: Range = "12m";
export { RANGES, type Range };

export function useView(): {
  installation: string;
  range: Range;
  /** A path with the current view's query string. */
  href: (path: string) => string;
  setInstallation: (installation: string) => void;
  setRange: (range: Range) => void;
} {
  const { pathname, search } = useLocation();
  const installation = search.get("installation") || DEFAULT_INSTALLATION;
  const rangeParam = search.get("range");
  const range = (RANGES as readonly string[]).includes(rangeParam ?? "")
    ? (rangeParam as Range)
    : DEFAULT_RANGE;
  const query = (changes: Record<string, string>) => {
    const next = new URLSearchParams(search);
    for (const [key, value] of Object.entries(changes)) next.set(key, value);
    return `?${next.toString()}`;
  };
  return {
    installation,
    range,
    href: (path) => `${path}${search.size ? `?${search.toString()}` : ""}`,
    setInstallation: (value) =>
      navigate(`${pathname}${query({ installation: value })}`, { replace: true }),
    setRange: (value) => navigate(`${pathname}${query({ range: value })}`, { replace: true }),
  };
}
